export default __webpack_public_path__ + "static/media/bannernew.f6928088.png";